/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { PlanStructureModule, SisComponentsModule } from 'sis-components';
import { StudentCommonModule } from '../common/common.module';
import { PlanCommonModule } from '../common/components/plan-common/plan-common.module';
import { EmrexResultModalComponent } from '../plan/emrex-result-modal/emrex-result-modal.component';
import { OutdatedCourseUnitsModalComponent } from '../plan/outdated-course-units-modal/outdated-course-units-modal.component';
import { SelectCompletionMethodComponent } from '../plan/select-completion-method/select-completion-method.component';
import { SelectEmrexAccessPointModalComponent } from '../plan/select-emrex-access-point-modal/select-emrex-access-point-modal.component';
import { AddToPlanWizardPreviewAndConfirmStepComponent } from './add-to-plan-wizard/add-to-plan-wizard-preview-and-confirm-step/add-to-plan-wizard-preview-and-confirm-step.component';
import { AddToPlanWizardSelectDestinationStepComponent } from './add-to-plan-wizard/add-to-plan-wizard-select-destination-step/add-to-plan-wizard-select-destination-step.component';
import { AddToPlanWizardComponent } from './add-to-plan-wizard/add-to-plan-wizard.component';
import { PlanStructureModuleSummaryComponent } from './add-to-plan-wizard/plan-structure-module-summary/plan-structure-module-summary.component';
import { ApplyForModuleContentWorkflowDialogComponent } from './apply-for-module-content-workflow-dialog/apply-for-module-content-workflow-dialog.component';
import { CopyPlanModalComponent } from './copy-plan-modal/copy-plan-modal.component';
import { CreateFirstPlanComponent } from './create-first-plan/create-first-plan.component';
import { CreatePlanModalComponent } from './create-plan-modal/create-plan-modal.component';
import { EditPlanNgNameModalComponent } from './edit-plan-ng-name-modal/edit-plan-ng-name-modal.component';
import { ModuleContentWorkflowDialogComponent } from './module-content-workflow-dialog/module-content-workflow-dialog.component';
import { PlanNgComponent } from './plan-ng.component';
import { planStates } from './plan-ng.route';
import { PlanNotificationComponent } from './plan-notification/plan-notification.component';
import { PlanStructureComponent } from './plan-structure/plan-structure.component';
import { PlanVersionToggleComponent } from './plan-version-toggle/plan-version-toggle.component';
import { UnallocatedCourseUnitAttainmentsDialogComponent } from './unallocated-course-unit-attainments-dialog/unallocated-course-unit-attainments-dialog.component';

@NgModule({
    declarations: [
        AddToPlanWizardComponent,
        AddToPlanWizardSelectDestinationStepComponent,
        AddToPlanWizardPreviewAndConfirmStepComponent,
        ApplyForModuleContentWorkflowDialogComponent,
        ModuleContentWorkflowDialogComponent,
        OutdatedCourseUnitsModalComponent,
        PlanNgComponent,
        PlanStructureComponent,
        PlanVersionToggleComponent,
        EditPlanNgNameModalComponent,
        CopyPlanModalComponent,
        CreatePlanModalComponent,
        CreateFirstPlanComponent,
        PlanNotificationComponent,
        PlanStructureModuleSummaryComponent,
        SelectCompletionMethodComponent,
        SelectEmrexAccessPointModalComponent,
        EmrexResultModalComponent,
        UnallocatedCourseUnitAttainmentsDialogComponent,
    ],
    imports: [
        PlanCommonModule,
        PlanStructureModule,
        UIRouterModule.forChild({ states: planStates }),
        CommonModule,
        SisComponentsModule,
        SisCommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgxFudisModule,
        StudentCommonModule,
    ],
})
export class PlanNgModule {}
